import { Anchor, Stack, Text, Title } from "@mantine/core";
import { modals } from "@mantine/modals";

const ATTRIBUTIONS_MODAL_ID = "attributions";

const openAttributionsModal = () => {
  modals.open({
    modalId: ATTRIBUTIONS_MODAL_ID,
    title: "Copyrights & Attributions",
    withCloseButton: true,
    centered: true,
    size: "lg",
    children: (
      <Stack gap="md" p="md">
        <div>
          <Title order={4}>Map Data</Title>
          <Text size="sm" c="dimmed">
            Map data © OpenStreetMap contributors, available under the{" "}
            <Anchor
              href="https://www.openstreetmap.org/copyright"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Database License
            </Anchor>
            .
          </Text>
        </div>

        <div>
          <Title order={4}>Mapping Technology</Title>
          <Text size="sm" c="dimmed">
            Interactive maps powered by{" "}
            <Anchor
              href="https://maplibre.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              MapLibre GL JS
            </Anchor>
            , an open-source mapping library.
          </Text>
        </div>

        <div>
          <Title order={4}>Public Lands Data</Title>
          <Text size="sm" c="dimmed">
            Public lands boundaries from the USGS{" "}
            <Anchor
              href="https://www.usgs.gov/programs/gap-analysis-project/science/pad-us-data-overview"
              target="_blank"
              rel="noopener noreferrer"
            >
              Protected Areas Database (PAD-US)
            </Anchor>
            . Data is in the public domain.
          </Text>
        </div>

        <div>
          <Title order={4}>Weather & Climate Data</Title>
          <Text size="sm" c="dimmed">
            Historical climate data from{" "}
            <Anchor
              href="https://prism.oregonstate.edu/"
              target="_blank"
              rel="noopener noreferrer"
            >
              PRISM Climate Group
            </Anchor>
            , Oregon State University. Data created with funding from multiple
            federal agencies.
          </Text>
        </div>

        <div>
          <Title order={4}>Campground Data</Title>
          <Text size="sm" c="dimmed">
            Campground information sourced from OpenStreetMap contributors and
            user-generated content. Images may be contributed by users and are
            subject to individual copyright.
          </Text>
        </div>

        <div>
          <Title order={4}>Geocoding & Routing</Title>
          <Text size="sm" c="dimmed">
            Address search powered by{" "}
            <Anchor
              href="https://radar.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Radar
            </Anchor>
            . Travel time calculations powered by{" "}
            <Anchor
              href="https://valhalla.github.io/valhalla/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Valhalla
            </Anchor>
            .
          </Text>
        </div>

        <div>
          <Title order={4}>Icons</Title>
          <Text size="sm" c="dimmed">
            Icons from{" "}
            <Anchor
              href="https://fontawesome.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Font Awesome
            </Anchor>
            .
          </Text>
        </div>

        <Text size="xs" c="dimmed" mt="xl" ta="center">
          I Wanna Camp is an independent project and is not affiliated with or
          endorsed by any government agency or the organizations mentioned
          above.
        </Text>
      </Stack>
    ),
    styles: {
      title: {
        flex: 1,
      },
      header: {
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
  });
};

export { ATTRIBUTIONS_MODAL_ID, openAttributionsModal };
